import { render } from "./BundleBagPanel.vue?vue&type=template&id=0090c32c"
import script from "./BundleBagPanel.vue?vue&type=script&lang=js"
export * from "./BundleBagPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/bundle-builder/components/BundleBagPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0090c32c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0090c32c', __exports__)) {
    api.reload('0090c32c', __exports__)
  }
  
  module.hot.accept("./BundleBagPanel.vue?vue&type=template&id=0090c32c", () => {
    api.rerender('0090c32c', render)
  })

}


export default __exports__